var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.31,
    height: 35.68,
    viewBox: "0 0 32.31 35.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20047",
    "data-name": "Rectangle 20047",
    width: 32.31,
    height: 35.68,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_101699",
    "data-name": "Group 101699",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101699-2",
    "data-name": "Group 101699",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20046",
    "data-name": "Path 20046",
    d: "M24.12,2.58l-.22-.02V1.01a1.015,1.015,0,0,0-2.03,0V2.53H10.44V1.01A1.009,1.009,0,0,0,9.45.04H9.42a1.03,1.03,0,0,0-.69.27,1.02,1.02,0,0,0-.32.71V2.56l-.23.02C2.9,3.03,0,6.36,0,11.95v14.3c0,5.99,3.43,9.43,9.42,9.43H22.88c5.99,0,9.43-3.44,9.43-9.43V11.95c0-5.59-2.91-8.92-8.19-9.37m6.17,23.67c0,4.98-2.42,7.41-7.41,7.41H9.42c-4.98,0-7.4-2.43-7.4-7.41V13.96H30.29ZM2.52,11.93H2.031v-.5C2.18,7.29,4.24,5,8.14,4.61l.27-.02V6.06a1.016,1.016,0,0,0,.98.98.963.963,0,0,0,.73-.28.979.979,0,0,0,.32-.7V4.55H21.87V6.06a1.015,1.015,0,0,0,2.03,0V4.58l.27.03c3.98.39,6.03,2.77,6.11,7.06l.01.26Z",
    fill: "#59687d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20047",
    "data-name": "Path 20047",
    d: "M11.57,20.38c-.01.09-.02.19-.03.28a1.094,1.094,0,0,1-.09.25,1.505,1.505,0,0,1-.11.22,1.987,1.987,0,0,1-.16.2,1.42,1.42,0,0,1-.89.39h-.06a1.348,1.348,0,0,1-.52-.11,1.267,1.267,0,0,1-.82-1.22,1.447,1.447,0,0,1,.1-.51,1.746,1.746,0,0,1,.28-.44,1.313,1.313,0,0,1,.45-.28,1.288,1.288,0,0,1,.51-.1,1.357,1.357,0,0,1,.94.37,1.431,1.431,0,0,1,.4.95",
    fill: "#59687d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20048",
    "data-name": "Path 20048",
    d: "M17.49,20.38a2.635,2.635,0,0,1-.02.28,1.432,1.432,0,0,1-.1.25.57.57,0,0,1-.11.22,1.165,1.165,0,0,1-.16.2,1.4,1.4,0,0,1-.88.39h-.06a1.348,1.348,0,0,1-.52-.11,1.275,1.275,0,0,1-.83-1.22,1.455,1.455,0,0,1,.11-.51,1.234,1.234,0,0,1,.73-.73,1.337,1.337,0,0,1,.52-.1,1.317,1.317,0,0,1,.93.38,1.374,1.374,0,0,1,.39.95",
    fill: "#59687d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20049",
    "data-name": "Path 20049",
    d: "M23.42,20.37a1.265,1.265,0,0,1-.03.28.762.762,0,0,1-.09.25,1.229,1.229,0,0,1-.11.23c-.05.07-.11.14-.16.2a1.42,1.42,0,0,1-.95.39,1.3,1.3,0,0,1-.51-.11,1.358,1.358,0,0,1-.42-.26l-.18-.22a1.247,1.247,0,0,1-.13-.26.864.864,0,0,1-.07-.21,1.39,1.39,0,0,1-.03-.27,1.469,1.469,0,0,1,.38-.95,1.338,1.338,0,0,1,.45-.29,1.387,1.387,0,0,1,.52-.11,1.35,1.35,0,0,1,.94.39,1.466,1.466,0,0,1,.39.94",
    fill: "#59687d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20050",
    "data-name": "Path 20050",
    d: "M11.18,27.26a1.41,1.41,0,0,1-.95.38,1.255,1.255,0,0,1-.51-.1,1.652,1.652,0,0,1-.44-.28,1.374,1.374,0,0,1-.39-.95A1.348,1.348,0,0,1,9,25.79a1.194,1.194,0,0,1,.26-.42,1.372,1.372,0,0,1,.88-.33.34.34,0,0,1,.1.01,1.346,1.346,0,0,1,.93.46,1.36,1.36,0,0,1,.01,1.75",
    fill: "#59687d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20051",
    "data-name": "Path 20051",
    d: "M17.49,26.31a1.315,1.315,0,0,1-1.31,1.33h-.04a1.329,1.329,0,0,1-1.33-1.33,1.361,1.361,0,0,1,.12-.52,1.086,1.086,0,0,1,.27-.42,1.388,1.388,0,0,1,.96-.38,1.348,1.348,0,0,1,.94.37,1.207,1.207,0,0,1,.29.44,1.323,1.323,0,0,1,.1.51",
    fill: "#59687d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20052",
    "data-name": "Path 20052",
    d: "M23.04,27.25a1.408,1.408,0,0,1-.85.4l-.11-.01a1.391,1.391,0,0,1-.95-.38,1.313,1.313,0,0,1-.28-.45,1.291,1.291,0,0,1,0-1.02,1.146,1.146,0,0,1,.28-.43,1.333,1.333,0,0,1,.94-.39,1.241,1.241,0,0,1,.27.03.763.763,0,0,1,.26.08.776.776,0,0,1,.22.12,1.915,1.915,0,0,1,.21.16,1.34,1.34,0,0,1,.01,1.89",
    fill: "#59687d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5497e0b3d8edc3f6807dd66a56d3b7ee.svg";
export { ForwardRef as ReactComponent };